// Contentful
import React from 'react';
import safeJsonStringify from 'safe-json-stringify';
import contentfulClient from '../client/contentful';

// Components
import Footer from '../components/Footer/Footer';
import Navigation from '../components/Navigation/Navigation';
import PageWrapper from '../components/PageWrapper/PageWrapper';
import PropositionBlock from '../components/PropositionBlock/PropositionBlock';
import ContentToggle from '../components/ContentToggle/ContentToggle';
import ClientsOverview from '../components/ClientsOverview/ClientsOverview';
import CallToAction from '../components/CallToAction/CallToAction';
import SeoMeta from '../components/SeoMeta/SeoMeta';

// Data Utils
import getContentToggleData from '../utils/data/getContentToggleData';
import getClientsOverviewData from '../utils/data/getClientsOverviewData';
import getCallToActionData from '../utils/data/getCallToActionData';
import getProductHeaderData from '../utils/data/getProductHeaderData';
import getPropositionBlockData from '../utils/data/getPropositionBlockData';
import getSeoData from '../utils/data/getSeoData';
import useOpenGraphImage from '../utils/useOpenGraphImage';
import ProductHeader from '../components/ProductHeader/ProductHeader';

const Product = (props) => {
  const data = props.data.fields;

  const { seoImageURL } = useOpenGraphImage('/home');
  const seoData = getSeoData(data, seoImageURL);

  const productHeaderData = getProductHeaderData(data);
  const propositionBlockTopData = getPropositionBlockData(data.propositionsTop);

  const contentToggleData =
    data?.inbound?.length >= 1 && data?.outbound?.length >= 1
      ? getContentToggleData([
          { label: 'Inbound', data: data.inbound },
          { label: 'Outbound', data: data.outbound },
        ])
      : false;

  const clientsOverviewData = data?.clientsOverview ? getClientsOverviewData(data.clientsOverview) : false;
  const callToActionData = getCallToActionData(data.cta);

  return (
    <>
      <SeoMeta {...seoData} />
      <PageWrapper modifier="PageWrapper--productPage">
        <Navigation />
        {productHeaderData && <ProductHeader {...productHeaderData} modifier="ProductHeader--productPage" />}
        {propositionBlockTopData && <PropositionBlock {...propositionBlockTopData} />}
        {contentToggleData && (
          <ContentToggle
            {...contentToggleData}
            onToggle={() => window.analytics.track('[Website] Inbound/outbound toggle')}
          />
        )}
        {clientsOverviewData && (
          <ClientsOverview {...clientsOverviewData} modifiers={['ClientsOverview--productPage']} />
        )}
        {callToActionData && <CallToAction {...callToActionData} source="product-page" />}
      </PageWrapper>
      <Footer />
    </>
  );
};

export async function getStaticProps() {
  let data = {};

  const client = contentfulClient;

  await client.getEntry('7fekKA2lvrzv23X1XNwZLU', { include: 10 }).then((entry) => {
    data = JSON.parse(safeJsonStringify(entry));
  });
  return {
    props: { data },
  };
}

export default Product;
